import { useCallback, useEffect, useState } from 'react';
import { Form, Select } from 'antd';
import {
  ISettingProperties,
  ISettingToUpdate,
  ISettingType,
} from '../../interfaces/TenantSetting';
import GraphqlService from '../../services/graphql/GraphqlService';
import { Query } from '../../services/graphql/query';

type ReceiptDescriptionEnumSelectProps = {
  settingsArray: ISettingToUpdate[];
  handleChange: (id: any, value: any) => void;
};

export const useSettingReceiptDescriptionEnum = (
  props: ReceiptDescriptionEnumSelectProps,
) => {
  const { settingsArray, handleChange } = props;

  const { customRequest } = GraphqlService();
  const [descriptionFormats, setDescriptionFormats] = useState<any[]>([]);

  useEffect(() => {
    const fetchDescriptionFormats = async () => {
      const data: any = await customRequest({
        query: Query.descriptionFormats,
        variables: {
          filter: {
            visible: true,
          },
        },
      })
        .then((data) => {
          return data;
        })
        .catch((error) => {
          return error;
        });

      if (data && Array.isArray(data)) {
        setDescriptionFormats(data);
      }
    };

    fetchDescriptionFormats();
  }, []);

  const ReceiptDescriptionEnumSelect = useCallback(
    (props: ISettingProperties) => {
      const valueSelected = settingsArray
        .find((item) => item.id === props.id)
        ?.value?.toString();

      return (
        <Form.Item
          className="margin-component"
          required
          key={props.key || undefined}
        >
          <Select
            className="select-receipt-description-enum"
            onChange={(e) => handleChange(props.id, e)}
            value={valueSelected}
            getPopupContainer={(node) => node.parentNode}
            options={descriptionFormats.map((item) => ({
              label: item.description || item.code,
              value: item.code,
            }))}
          />
        </Form.Item>
      );
    },
    [settingsArray, handleChange, descriptionFormats],
  );

  const receiptDescriptionEnumSetting: ISettingType = {
    render: useCallback(
      (props) => {
        return <ReceiptDescriptionEnumSelect {...props} />;
      },
      [ReceiptDescriptionEnumSelect],
    ),
  };

  return { receiptDescriptionEnumSetting };
};

export default useSettingReceiptDescriptionEnum;
